import React, { useState, useEffect, useCallback } from "react";
import BannerSection from "../../../Alumni/Partials/Banner";
import "./SportsCommon.css";

const TournamentSports = () => {
  const [activeTab, setActiveTab] = useState("files");
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const galleryItems = [
    { src: "/assets/images/sports4.webp", caption: "#Captions" },
    { src: "/assets/images/sports3.webp", caption: "#Captions" },
    { src: "/assets/images/sports5.webp", caption: "#Captions" },
    { src: "/assets/images/sports1.webp", caption: "#Captions" },
    { src: "/assets/images/sports7.webp", caption: "#Captions" },
    { src: "/assets/images/sports6.webp", caption: "#Captions" },
  ];

  const openLightbox = (index) => {
    setCurrentIndex(index);
    setLightboxOpen(true);
  };

  const closeLightbox = () => setLightboxOpen(false);

  const showNext = useCallback(() => {
    setCurrentIndex((prev) => (prev + 1) % galleryItems.length);
  }, [galleryItems.length]);

  const showPrev = useCallback(() => {
    setCurrentIndex(
      (prev) => (prev - 1 + galleryItems.length) % galleryItems.length,
    );
  }, [galleryItems.length]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!lightboxOpen) return;

      if (e.key === "Escape") closeLightbox();
      if (e.key === "ArrowRight") showNext();
      if (e.key === "ArrowLeft") showPrev();
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [lightboxOpen, showNext, showPrev]);

  return (
    <>
      <BannerSection />

      <section className="sports-common-section">
        <div className="achievement-container">
          <div className="sec-title text-center">
            <h2> TOURNAMENTS</h2>
          </div>

          {/* TAB BUTTONS */}
          <div className="tabs-container">
            <div className="tab-nav">
              <button
                className={`tab-btn ${activeTab === "files" ? "active" : ""}`}
                onClick={() => setActiveTab("files")}
              >
                <i className="fa fa-files-o text-danger"></i> Files
              </button>

              <button
                className={`tab-btn ${activeTab === "gallery" ? "active" : ""}`}
                onClick={() => setActiveTab("gallery")}
              >
                <i className="fa fa-picture-o text-dark"></i> Gallery
              </button>

              <button
                className={`tab-btn ${activeTab === "videos" ? "active" : ""}`}
                onClick={() => setActiveTab("videos")}
              >
                <i className="fa fa-youtube-play text-danger"></i> Videos
              </button>
            </div>

            {/* TAB CONTENT */}
            <div className="tab-content-wrapper">
              {/* FILES TAB */}
              {activeTab === "files" && (
                <div className="tab-content active">
                  <ul className="achievement-list">
                    <li>
                      <a href="https://care.edu.in/wp-content/uploads/2020/04/SPORTS-PHOTOS-SOUTH-ZONE-1.pdf">
                        <i className="link-icon fa fa-file-pdf-o"></i>
                        <span>
                          SOUTH ZONE INTER UNIVERSITY KHO-KHO WOMEN TOURNAMENT
                          2016-17
                        </span>
                      </a>
                    </li>

                    <li>
                      <a href="https://care.edu.in/wp-content/uploads/2020/04/SPORTS-PHOTOS-INDIA-1.pdf">
                        <i className="link-icon fa fa-file-pdf-o"></i>
                        <span>
                          ALL INDIA INTER ZONAL UNIVERSITY KHO-KHO WOMEN
                          TOURNAMENT 2016-17
                        </span>
                      </a>
                    </li>

                    <li>
                      <a href="https://care.edu.in/wp-content/uploads/2020/04/chetfest2011.pdf">
                        <i className="link-icon fa fa-file-pdf-o"></i>
                        <span>Chetfest Sports 2011</span>
                      </a>
                    </li>
                  </ul>
                </div>
              )}

              {/* GALLERY TAB */}
              {activeTab === "gallery" && (
                <div className="tab-content active">
                  <div className="gallery-grid">
                    {galleryItems.map((item, index) => (
                      <div
                        key={index}
                        className="gallery-item"
                        onClick={() => openLightbox(index)}
                      >
                        <img src={item.src} alt={item.caption} />
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* VIDEOS TAB */}
              {activeTab === "videos" && (
                <div className="tab-content active">
                  <div className="video-grid">
                    <div className="video-item">
                      <iframe
                        src="https://www.youtube.com/embed/kFuk28lCT-s?si=xDgjeqQk3E0nlIx7"
                        allowFullScreen
                        title="video1"
                      ></iframe>
                    </div>

                    <div className="video-item">
                      <iframe
                        src="https://www.youtube.com/embed/5Jw_vK0JdLc?si=OlFHvqj19mHjZZwQ"
                        allowFullScreen
                        title="video2"
                      ></iframe>
                    </div>

                    <div className="video-item">
                      <iframe
                        src="https://www.youtube.com/embed/9W-QDsZT4oo?si=HYASogRv1NAlUhNa"
                        allowFullScreen
                        title="video3"
                      ></iframe>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* LIGHTBOX MODAL */}
        {lightboxOpen && (
          <div className="lightbox-modal active" onClick={closeLightbox}>
            <span className="lightbox-close">&times;</span>

            <div
              className="lightbox-content"
              onClick={(e) => e.stopPropagation()}
            >
              <img src={galleryItems[currentIndex].src} alt="" />
              <div className="lightbox-caption">
                {galleryItems[currentIndex].caption}
              </div>
            </div>

            <a
              className="lightbox-nav lightbox-prev"
              onClick={(e) => {
                e.stopPropagation();
                showPrev();
              }}
            >
              &#10094;
            </a>

            <a
              className="lightbox-nav lightbox-next"
              onClick={(e) => {
                e.stopPropagation();
                showNext();
              }}
            >
              &#10095;
            </a>
          </div>
        )}
      </section>
    </>
  );
};

export default TournamentSports;
